import UnavailableFeatureDialog from "../component/UnavailableFeatureDialog";
import liveVendors from "./referenceLiveVendors.json";
import ReferenceVendorPage from "./ReferenceVendorPage";
import { useState, useEffect, useLayoutEffect, useRef } from "react";
import Layout from "./Layout";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { isEmpty, lowerCase } from "lodash";
import { toast } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import {
  Fishing,
  FishingPlatform,
  HomeCasino,
  LiveCasino,
  LiveCasinoPlatform,
  PlatformObject,
  PokerPlatform,
  SlotNew,
  Slots,
  SlotsPlatform,
} from "./casino/CasinoList";
import { FaHeart } from "react-icons/fa";
import { t } from "i18next";

const Casino = ({ category } = {}) => {
  const [show, setShow] = useState("");
  const [unavailableFeature, setUnavailableFeature] = useState("");
  const [collection, setCollection] = useState("all");
  const [favorites, setFavorites] = useState(() => { try { return JSON.parse(localStorage.getItem("chorki-ui-favorites") || "[]"); } catch { return []; } });
  const [recentGames, setRecentGames] = useState(() => { try { return JSON.parse(localStorage.getItem("chorki-ui-recent-games") || "[]"); } catch { return []; } });
  const gameKey = (game) => `${game.platForm || game.platFormCode}:${game.name || game.title}`;
  const toggleFavorite = (event, game) => { event.stopPropagation(); const key = gameKey(game); const next = favorites.includes(key) ? favorites.filter(item => item !== key) : [...favorites,key]; setFavorites(next); localStorage.setItem("chorki-ui-favorites", JSON.stringify(next)); };
  const [inner, setInner] = useState("FC");
  const location = useLocation();
  const navigate = useNavigate();
  const { type: routeType } = useParams();
  const type = category || routeType;
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const setLoginModal = useContextSelector(
    AuthContext,
    (ctx) => ctx.setLoginModal,
  );
  const launchCasino = useContextSelector(
    AuthContext,
    (ctx) => ctx.launchCasino,
  );
  const providerLogoCode = key => ({ JILI: "JL", SPRIBE: "SPB", SPADE: "SG", JOKER: "JK", NETENT: "NE", FASTSPIN: "FS", PLAYNGO: "PNG", EVO: type === "live" ? "EG4" : "EP", EVOLUTION: "EG4", KINGMAKER: "KM", SEXYBCRT: "SEX", DREAMGAMING: "DG", VIACASINO: "VIA", KP: "KP", BSP: "BSP", RG: "RG" })[key] || key;
  const whiteLogoCodes = new Set(["FC", "SPB", "JDB", "JL", "PG", "PP", "RT", "EP", "SG", "YB", "BTG", "JK", "NE", "NLC", "FS", "KM", "PT", "PNG", "EG4", "SEX", "DG", "VIA", "BG", "KP", "BSP", "RG"]);
  const pvpProviderLogo = {
    KP: "/assets/bdtwin/KP-WHITE.png",
    BSP: "/assets/bdtwin/BSP-WHITE.png",
    KINGMAKER: "/assets/bdtwin/KM-WHITE.png",
    RG: "/assets/bdtwin/RG-WHITE.png",
  };
  const referencePokerOrder = [
    "KM0021",
    "KM0029",
    "KM0008",
    "BSP051",
    "KM0011",
    "KM0072",
    "KM0092",
    "KM0009",
    "KM0032",
    "KM0012",
    "KM0015",
    "KM0024",
    "KM0083",
    "KM0002",
    "KM0044",
  ];
  const pokerAssetKey = (game) => String(game?.img || "").split("/").pop().replace(/\.\w+$/, "");
  const sortPokerCatalog = (games = []) => {
    const rank = (game) => {
      const index = referencePokerOrder.indexOf(pokerAssetKey(game));
      return index === -1 ? referencePokerOrder.length + 1 : index;
    };
    return [...games].sort((a, b) => {
      const diff = rank(a) - rank(b);
      if (diff !== 0) return diff;
      return String(a?.name || "").localeCompare(String(b?.name || ""));
    });
  };
  const matchesPokerProvider = (game, providerKey) => {
    if (!providerKey || providerKey === "all") return true;
    const code = game?.platFormCode || game?.platForm || "";
    const img = `${game?.img || ""} ${game?.vendor || ""}`;
    if (providerKey === "KP") return /\/KP\d+|KP-COLOR|Kings? Poker/i.test(img) || code === "KP";
    if (providerKey === "BSP") return /BSP|BAISON/i.test(`${code} ${img}`);
    if (providerKey === "RG") return /RGSlot|\bRG\b|\/RG-/i.test(`${code} ${img}`);
    return code === providerKey;
  };
  const params = new URLSearchParams(location.search);
  const innerType = params.get("type") || "";


  const objectList = {
    hot: HomeCasino?.HotGame,
    jili: HomeCasino?.JiliSlots,
    pg: HomeCasino?.PGSlots,
    slots: [...Slots, ...SlotNew],
    live: LiveCasino,
    fish: Fishing,
    poker: HomeCasino?.Poker,
    sports: HomeCasino?.Sports,
    lottery: [],
  };

  const providerSwiperRef = useRef(null);
  const classScrollRef = useRef(null);
  const [classCanPrev, setClassCanPrev] = useState(false);
  const [classCanNext, setClassCanNext] = useState(false);
  const [providerCanPrev, setProviderCanPrev] = useState(false);
  const [providerCanNext, setProviderCanNext] = useState(false);
  const syncProviderNav = (swiper) => {
    if (!swiper || swiper.destroyed) return;
    setProviderCanPrev(!swiper.isLocked && !swiper.isBeginning);
    setProviderCanNext(!swiper.isLocked && !swiper.isEnd);
  };
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(30);
  const [catalogPage, setCatalogPage] = useState(1);
  const [list, setList] = useState([]); // original list (based on type)
  const [searchTerm, setSearchTerm] = useState(""); // current search text
  const [filteredList, setFilteredList] = useState([]); // filtered list after search
  const [hasMore, setHasMore] = useState(true);
  const [pokerClass, setPokerClass] = useState("all");
  const pokerCategories = [
    { label: lang === "bn" ? "সব" : "All", value: "all" },
    { label: lang === "bn" ? "মাল্টিপ্লেয়ার গেম" : "Multiplayer game", value: "LIVE" },
    { label: lang === "bn" ? "অন্যান্য" : "Others", value: "OTHERS" },
    { label: lang === "bn" ? "যুদ্ধ খেলা" : "Battle game", value: "BATTLE" },
    { label: lang === "bn" ? "পিভিপি টেবিল গেম" : "PVP Table Game", value: "TABLE" },
  ];
  const pokerTitleBn = {
    "7 Up 7 Down": "৭ আপ ৭ ডাউন",
    "Coin Toss": "মুদ্রা নিক্ষেপ",
    "Sic Bo": "সিক বো",
    "Andar Bahar": "অন্দর বাহার",
    "Poker Roulette": "পোকার রুলেট",
    "Dice Duet": "ডাইস দুয়েট",
    "7 Up 7 Down Rush": "৭ আপ ৭ ডাউন রাশ",
    "Tai Xiu": "তাই শিউ",
    "32 Cards": "৩২টি কার্ড",
    "Thai Fish Prawn Crab": "থাই মাছ, চিংড়ি ও কাঁকড়া",
    "Triple Chance": "ট্রিপল চান্স",
    "Speedy Andar Bahar": "দ্রুত অ্যান্ডার বাহার",
    "Thai Hi Lo 2": "থাই হাই লো ২",
    "Color Game": "রঙের খেলা",
  };
  const displayGameName = (game) => {
    const name = game?.title || game?.name || "";
    if (lang === "bn" && lowerCase(show) === "poker") {
      if (pokerAssetKey(game) === "KM0024") return "আন্দর বাহার";
      return pokerTitleBn[name] || name;
    }
    return name;
  };
  const slotCategories = [
    "All",
    "3 Reels",
    "5 Reels",
    "Arcade",
    "Bingo",
    "Bonus Game",
    "Cascade Slots",
    "Crash Games",
    "Cricket",
    "Feature Buy",
    "Free Spin",
  ];
  const slotProviderOrder = [
    ["JILI", "Jili"],
    ["PG", "Pocket Games Soft"],
    ["SPRIBE", "Spribe"],
    ["FC", "FA CHAI Gaming"],
    ["BNG", "BNG"],
    ["JDB", "JDB"],
    ["MG", "Micro Gaming"],
    ["NG", "Naga Games"],
    ["L22", "Live22"],
    ["SPADE", "Spadegaming"],
    ["FP", "First Person"],
  ];
  const slotProviders = slotProviderOrder.map(([key, name]) => {
    const provider = SlotsPlatform.find((item) => item?.key === key);
    return {
      key,
      name,
      logoCode: { JILI: "JL", SPRIBE: "SPB", SPADE: "SG" }[key] || key,
      img: provider?.img,
      unavailable: !provider,
    };
  });
  const fishCategories = ["All", "Fishing Machine", "Fishing Machine Jackpot"];
  const fishProviderOrder = [
    ["JL", "JILI", "Jili"],
    ["FC", "FC", "FA CHAI"],
    ["JDB", "JDB", "JDB"],
    ["FTG", "FTG", "FunTa Gaming"],
    ["BT", "BTG", "BTGaming"],
    ["FS", "FASTSPIN", "Fastspin"],
    ["BSP", "BSP", "Baison Poker"],
    ["JK", "JOKER", "Joker"],
    ["KA", "KA", "KA Gaming"],
    ["SG", "SPADE", "Spadegaming"],
    ["MG", "MG", "Micro Gaming"],
    ["AMBS", "AMBS", "AMBS"],
    ["CQ9", "CQ9", "CQ9"],
    ["SWG", "SWG", "SWG"],
    ["MW", "MW", "MW"],
    ["2J", "2J", "2J"],
    ["FG", "FG", "FG"],
  ];
  const fishProviders = fishProviderOrder.map(([logoCode, key, name]) => ({
    key,
    name,
    logoCode,
    unavailable: !(objectList.fish || []).some((game) => game?.platForm === key),
  }));
  const pokerProviders = PokerPlatform.map((provider) => ({
    ...provider,
    logoCode: { KP: "KP", BSP: "BSP", KINGMAKER: "KM", RG: "RG" }[provider.key],
  }));
  const catalogCategories = lowerCase(show) === "fish" ? fishCategories : slotCategories;
  const catalogProviders = lowerCase(show) === "slots"
    ? slotProviders
    : lowerCase(show) === "fish"
      ? fishProviders
      : lowerCase(show) === "poker"
        ? pokerProviders
        : LiveCasinoPlatform;
  // ✅ Load casino list when type changes

  useEffect(() => {
    if (!isEmpty(type)) {
      setShow(type);
    }
    setInner(innerType || "all");
  }, [type, innerType]);
  useLayoutEffect(() => {
    const el = classScrollRef.current;
    if (!el) return undefined;
    const syncClassNav = () => {
      const max = el.scrollWidth - el.clientWidth;
      setClassCanPrev(el.scrollLeft > 2);
      setClassCanNext(max - el.scrollLeft > 2);
    };
    syncClassNav();
    el.addEventListener("scroll", syncClassNav, { passive: true });
    const observer = new ResizeObserver(syncClassNav);
    observer.observe(el);
    [...el.children].forEach((child) => observer.observe(child));
    window.addEventListener("resize", syncClassNav);
    return () => {
      el.removeEventListener("scroll", syncClassNav);
      observer.disconnect();
      window.removeEventListener("resize", syncClassNav);
    };
  }, [show, lang]);
  useEffect(() => {
    if (!isEmpty(show)) {
      const catalog = lowerCase(show);
      let data = ["slots", "live", "fish", "poker"].includes(catalog)
        ? objectList[catalog]?.filter((res) => {
            if (inner === "all") return true;
            if (catalog === "poker") return matchesPokerProvider(res, inner);
            return res?.platForm == inner;
          })
        : objectList[catalog];
      if (catalog === "poker") data = sortPokerCatalog(data || []);
      setList(data);
      setFilteredList(data);
      setVisible(30);
      setSearchTerm("");
      setHasMore(true);
      if (catalog === "poker") setPokerClass("all");
    }
  }, [show, inner]);

  // ✅ Search filter
  useEffect(() => {
    let selected = list || [];
    if (collection === "new") { const names = new Set(SlotNew.map(game => game.name || game.title)); selected = selected.filter(game => names.has(game.name || game.title)); }
    if (collection === "hot") { const names = new Set(HomeCasino.HotGame.map(game => game.name || game.title)); selected = selected.filter(game => names.has(game.name || game.title)); }
    if (collection === "recent") selected = selected.filter(game => recentGames.includes(gameKey(game)));
    if (collection === "favorites") selected = selected.filter(game => favorites.includes(gameKey(game)));
    if (lowerCase(show) === "poker" && pokerClass !== "all") {
      if (pokerClass === "OTHERS") {
        selected = selected.filter((game) => !["TABLE", "LIVE"].includes(game?.gameType));
      } else if (pokerClass === "BATTLE") {
        selected = selected.filter((game) => /battle|duel|war/i.test(game?.name || game?.title || ""));
      } else {
        selected = selected.filter((game) => game?.gameType === pokerClass);
      }
    }
    const query = searchTerm.trim().toLowerCase();
    setFilteredList(query ? selected.filter(game => (game.title || "").toLowerCase().includes(query) || (game.name || "").toLowerCase().includes(query)) : selected);
    setCatalogPage(1);
    setVisible(30); // reset visible count on new search
    setHasMore(true); // enable more data for search results
  }, [searchTerm, list, collection, favorites, recentGames, pokerClass, show]);

  // ✅ Load more for filtered list
  const loadMore = () => {
    setLoader(true);
    setVisible((prev) => {
      const next = prev + 30;
      if (next >= filteredList.length) {
        setHasMore(false);
      }
      setLoader(false);
      return next;
    });
  };

  // ✅ Limit visible games
  const useCatalogPagination = ["slots", "fish", "poker"].includes(type);
  const catalogPageCount = Math.ceil(filteredList.length / 15);
  const visibleList = useCatalogPagination ? filteredList.slice((catalogPage - 1) * 15, catalogPage * 15) : filteredList.slice(0, visible);
  const catalogPages = Array.from({ length: catalogPageCount }, (_, index) => index + 1).filter((page) => {
    if (catalogPageCount <= 7) return true;
    if (catalogPage <= 3) return page <= 5 || page >= catalogPageCount - 1;
    if (catalogPage >= catalogPageCount - 2) return page === 1 || page >= catalogPageCount - 4;
    return page === 1 || page === catalogPageCount || Math.abs(page - catalogPage) <= 2;
  });

  // ✅ Launch game or show login
  const handleGameClick = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error("Coming Soon");
      } else {
        if (!isEmpty(res?.gameid)) {
          // Specific game logic (optional)
        } else {
          const nextRecent = [gameKey(res), ...recentGames.filter(key => key !== gameKey(res))].slice(0,50);
          setRecentGames(nextRecent);
          localStorage.setItem("chorki-ui-recent-games", JSON.stringify(nextRecent));
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType,
          });
        }
      }
    } else {
      setLoginModal(true);
    }
  };

  if (lowerCase(show) === "sports") return <ReferenceVendorPage category="Sports" />;
  if (type === "live" && !innerType) return <Layout>
    <main className="reference-standalone-vendors reference-live-vendors br_main">
      <div className="reference-standalone-grid">{liveVendors.map(provider => <article key={provider.code} role="button" tabIndex={0} aria-label={`Select ${provider.name}`} onClick={() => {
        if (isEmpty(user)) setLoginModal(true);
        else if (provider.platform) navigate(`/live?type=${provider.platform}`);
        else setUnavailableFeature(provider.name);
      }} onKeyDown={event => { if (["Enter", " "].includes(event.key)) { event.preventDefault(); event.currentTarget.click(); } }}>
        <img src={provider.image} alt={provider.name} />{provider.logo && <img className="reference-standalone-logo" src={provider.logo} alt="" />}<div className="reference-standalone-name">{provider.name}</div>
      </article>)}</div>
    </main>
    {unavailableFeature && <UnavailableFeatureDialog feature={unavailableFeature} onClose={() => setUnavailableFeature("")} />}
  </Layout>;

  return (
    <Layout>
      <div
        data-v-cda160c8
        className={
          lowerCase(show) == "sports"
            ? "vendor-game-wrap br_main"
            : `egame_wrap br_main ${type === "hot" ? "chorki-hot-page" : ""}`
        }
      >
        <div
          data-v-cda160c8
          className={
            lowerCase(show) == "sports"
              ? "vendor-game-container"
              : "egame-container"
          }
        >
          {type === "hot" && <header className="chorki-hot-heading"><span className="chorki-hot-eyebrow">CHORKI COLLECTION</span><h1>{lang === "bn" ? "জনপ্রিয় গেমস" : "Hot Games"}</h1><p>{lang === "bn" ? "আপনার পছন্দের গেম খুঁজে নিন" : "Discover your next favorite game"}</p></header>}
          <div className="reference-catalog-toolbar">
            <div className="reference-catalog-collections" aria-label="Game collections">
              {[["new", "New", "new"], ["hot", "Hot", "hot"], ["recent", "Recent", "recent"], ["favorites", "Favorites", "fav"]].map(([key, label, icon]) => (
                <button type="button" key={key} title={label} aria-label={label} aria-pressed={collection === key} className={collection === key ? "active" : ""} onClick={() => setCollection(collection === key ? "all" : key)}>
                  <span style={{maskImage: `url(/assets/bdtwin/game-${icon}.svg)`, WebkitMaskImage: `url(/assets/bdtwin/game-${icon}.svg)`}} />
                </button>
              ))}
            </div>
            <div className="slsearch">
              <form className="search_form" onSubmit={event => event.preventDefault()}>
                <span className="submit_button" aria-hidden="true"><img src="/assets/bdtwin/game-search.svg?v=2" alt="" /></span>
                <input
                  type="text"
                  aria-label="Search games"
                  placeholder={["slots", "poker", "fish"].includes(lowerCase(show)) ? "Game Name" : t("SearchGames")}
                  value={searchTerm}
                  onChange={event => setSearchTerm(event.target.value)}
                />
              </form>
            </div>
          </div>
          <div className="reference-catalog-classification-wrap">
            <button
              type="button"
              className="reference-class-prev"
              aria-label="Previous categories"
              disabled={!classCanPrev}
              onClick={() => classScrollRef.current?.scrollBy({ left: -220, behavior: "smooth" })}
            >
              ‹
            </button>
            <div className="reference-catalog-classification" aria-label="Game categories" ref={classScrollRef}>
              {lowerCase(show) === "poker"
                ? pokerCategories.map((item) => (
                    <button
                      type="button"
                      key={item.value}
                      className={pokerClass === item.value ? "active" : ""}
                      onClick={() => {
                        setPokerClass(item.value);
                        setCatalogPage(1);
                      }}
                    >
                      {item.label}
                    </button>
                  ))
                : catalogCategories.map((label) => (
                    <button
                      type="button"
                      key={label}
                      className={label === "All" ? "active" : ""}
                      onClick={() => {
                        if (label === "All") {
                          setCollection("all");
                          setCatalogPage(1);
                        } else setUnavailableFeature(label);
                      }}
                    >
                      {label}
                    </button>
                  ))}
            </div>
            <button
              type="button"
              className="reference-class-next"
              aria-label="Next categories"
              disabled={!classCanNext}
              onClick={() => classScrollRef.current?.scrollBy({ left: 220, behavior: "smooth" })}
            >
              ›
            </button>
          </div>
          {["slots", "live", "fish", "poker"].includes(lowerCase(show)) && (
            <div className="vendor-swiper-container" data-v-cda160c8="">
              <div className="swiper-wrap">
                <Swiper slidesPerView="auto" spaceBetween={6} watchOverflow onSwiper={swiper => { providerSwiperRef.current = swiper; syncProviderNav(swiper); }} onSlideChange={syncProviderNav} onResize={syncProviderNav} onReachBeginning={syncProviderNav} onReachEnd={syncProviderNav} onFromEdge={syncProviderNav} onLock={syncProviderNav} onUnlock={syncProviderNav}>
                  <SwiperSlide><button type="button" className={`list-item reference-vendor-all ${inner === "all" ? "active" : ""}`} onClick={() => setInner("all")}>{["slots", "fish"].includes(lowerCase(show)) ? "All" : lang === "bn" ? "সব" : "All"}</button></SwiperSlide>
                  {catalogProviders?.map((res, i) => {
                    return (
                      <SwiperSlide key={i}>
                        <div
                          role="button" tabIndex={0} aria-label={res?.name} aria-pressed={inner === res?.key}
                          onClick={() => res?.unavailable ? setUnavailableFeature(res.name) : setInner(res?.key)}
                          onKeyDown={event => { if (["Enter", " "].includes(event.key)) { event.preventDefault(); res?.unavailable ? setUnavailableFeature(res.name) : setInner(res?.key); } }}
                          className={`list-item FC ${
                            inner == res?.key ? "active" : ""
                          }`}
                        >
                          <div className="game-icon" data-vassalage="FC">
                            {res?.logoCode ? (
                              <img
                                alt={res.name}
                                src={`/assets/bdtwin/providers/${res.logoCode}-WHITE.png`}
                              />
                            ) : res?.unavailable ? (
                              <span className="reference-provider-name">{res.name}</span>
                            ) : (
                              <img
                                alt={res?.name}
                                src={
                                  lowerCase(show) === "poker" && pvpProviderLogo[res?.key]
                                    ? pvpProviderLogo[res.key]
                                    : whiteLogoCodes.has(providerLogoCode(res?.key))
                                      ? `/assets/bdtwin/${providerLogoCode(res?.key)}-WHITE.png`
                                      : res?.img
                                }
                              />
                            )}
                          </div>{" "}
                          <span className="game-text" data-vassalage="FC">
                            {res?.name}
                          </span>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
                <button type="button" className="reference-provider-prev" aria-label="Previous providers" disabled={!providerCanPrev} onClick={() => providerSwiperRef.current?.slidePrev()}>‹</button>
                <button type="button" className="reference-provider-next" aria-label="Next providers" disabled={!providerCanNext} onClick={() => providerSwiperRef.current?.slideNext()}>›</button>
              </div>
            </div>
          )}
          {lowerCase(show) == "sports" ? (
            <div data-v-d01d587e className="vendor-game-list">
              {HomeCasino?.Sports?.map((res, i) => {
                return (
                  <div
                    onClick={() => {
                      if (!isEmpty(user)) {
                        let link = i == 0 ? "/sports-sky" : "/sports-velki";
                        window.location.href = link;
                      } else {
                        toast.error("Please login in order to access");
                      }
                    }}
                    data-v-d01d587e
                    className="game-item"
                  >
                    <img data-v-d01d587e src={res} alt="PIN" />{" "}
                    <div data-v-d01d587e className="btn-wrap">
                      <div data-v-d01d587e className="game-btn">
                        {t("PLAYNOW")}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div data-v-cda160c8 className="egame_content">
              <div data-v-cda160c8 className="row-wrap">
                {visibleList.length > 0 ? (
                  visibleList.map((res, i) => (
                    <div
                      key={i}
                      data-v-cda160c8
                      className="img-box"
                      onClick={() => handleGameClick(res)}
                    >
                      <div data-v-cda160c8 className="game-list-item">
                        <div className="img-box">
                          <img
                            src={res?.img}
                            alt={displayGameName(res)}
                            className="box-img"
                            loading="lazy"
                          />
                          <div className="reference-catalog-game-actions">
                            <button type="button" className="reference-catalog-play" onClick={event => { event.stopPropagation(); handleGameClick(res); }}>{t("PLAYNOW")}</button>
                            <button type="button" className="reference-catalog-trial" onClick={event => { event.stopPropagation(); setUnavailableFeature("Free trial"); }}>FREE TRIAL</button>
                          </div>
                          <button type="button" aria-label={`${favorites.includes(gameKey(res)) ? "Remove" : "Add"} ${displayGameName(res)} ${favorites.includes(gameKey(res)) ? "from" : "to"} favorites`} aria-pressed={favorites.includes(gameKey(res))} className="reference-game-favorite" onClick={event => toggleFavorite(event,res)}><FaHeart /></button>
                          <span className="vassalage-tag">
                            <img
                              src={
                                isEmpty(res?.vendor)
                                  ? PlatformObject[res?.platForm]
                                  : res?.vendor
                              }
                              alt=""
                            />
                          </span>
                          <span className="item-name">{displayGameName(res)}</span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div data-v-cda160c8 className="no-data">
                    No data
                  </div>
                )}
              </div>
              {useCatalogPagination && catalogPageCount > 1 && <nav className="reference-catalog-pagination" aria-label="Game pages">
                <button type="button" aria-label="Previous game page" disabled={catalogPage === 1} onClick={() => setCatalogPage(page => page - 1)}><span className="reference-page-direction-text">Prev</span><span className="reference-page-direction-icon" aria-hidden="true">‹</span></button>
                {catalogPages.map((page, index, pages) => <span key={page}>{index > 0 && page - pages[index - 1] > 1 && <span className="reference-page-break">…</span>}<button type="button" aria-current={catalogPage === page ? "page" : undefined} onClick={() => setCatalogPage(page)}>{page}</button></span>)}
                <button type="button" aria-label="Next game page" disabled={catalogPage === catalogPageCount} onClick={() => setCatalogPage(page => page + 1)}><span className="reference-page-direction-text">Next</span><span className="reference-page-direction-icon" aria-hidden="true">›</span></button>
              </nav>}
              {!useCatalogPagination && visible < filteredList.length && (
                <div
                  data-v-cda160c8
                  className="more-btn"
                  onClick={loadMore}
                  style={{
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                >
                  {t("Loadmore")}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {unavailableFeature && <UnavailableFeatureDialog feature={unavailableFeature} onClose={() => setUnavailableFeature("")} />}
    </Layout>
  );
};

export default Casino;
